export default __webpack_public_path__ + "static/media/LogoLanguage.2e5bce27.svg";